import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import { TextField } from '@material-ui/core'

import helpers from 'helpers'

// Campo único do CPF do representante no backoffice (T-23): pré-cadastro, empresa, troca de representante e
// usuário reusam este componente e o validador helpers.validates.cpf.
const ResponsibleCpfField = ({
  control,
  errors,
  name = 'responsibleCpf',
  label = 'CPF do representante',
  helperText = 'Opcional',
  disabled = false,
}) => {
  return (
    <Controller
      as={
        <TextField
          fullWidth
          inputProps={{ maxLength: 14 }}
          error={!!errors?.[name]}
          helperText={errors?.[name]?.message || helperText}
          label={label}
          disabled={disabled}
        />
      }
      onChange={([event]) => helpers.formatters.cpf(event.target.value)}
      control={control}
      name={name}
      mode="onBlur"
    />
  )
}

ResponsibleCpfField.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
}

export default ResponsibleCpfField
